export const costAnomaliesSortByCountValues = [6, 8, 10, 12, 14];

export const costAnomaliesWidgetSortByValues = new Map([
  ["sort_by_percentage", "Percentage"],
  ["sort_by_amount", "Cost Amount"],
]);
